export default "/_next/static/assets/fonts/Inter-Italic.8944f8c2a3dd2373bd6351e19e699d23.woff2";